import styled from 'styled-components';

export const Container = styled.div<{ $bottomOffset?: number }>`
  display: flex;
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: ${({ $bottomOffset = 0 }) => $bottomOffset}px;
  overflow: hidden;
`;
